export const MAIN_TITLE_SECTION_PLACEHOLDER = 'Saisir un titre de section';
